import {getGeoLocation} from '@/lib/locale/geoLocaltion'
import type {SupportedLocales} from '@/lib/locale/locale'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import {logError} from '@/utils/logger'

export async function getNavBanner({
  locale,
  signal,
}: {
  locale: SupportedLocales
  signal?: AbortSignal
}) {
  return call
    .post(
      '/api/model/site_header/',
      {
        localization: {
          locale,
          geo_location: getGeoLocation(),
        },
      },
      {
        signal,
      },
    )
    .then(response => {
      if (!response.data || typeof response.data !== 'string')
        throw new Error('Invalid response data')
      return response.data
    })
    .catch(e => {
      if (shouldLogError(e)) {
        logError(e)
      }
    })
}
